"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import { UnlockAppWalletModal } from "@/components/app-wallets/AppWalletModal";
export const useAppWalletPasswordModal = () => {
  const $ = _c(15);
  const [isOpen, setIsOpen] = useState(false);
  const [resolve, setResolve] = useState();
  const [reject, setReject] = useState();
  const [address, setAddress] = useState("");
  const [addressHashed, setAddressHashed] = useState("");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = (address_0, addressHashed_0) => {
      setAddress(address_0);
      setAddressHashed(addressHashed_0);
      setIsOpen(true);
      return new Promise((resolve_0, reject_0) => {
        setResolve(() => resolve_0);
        setReject(() => reject_0);
      });
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const requestPassword = t0;
  let handleCancel;
  let handlePasswordSubmit;
  if ($[1] !== reject || $[2] !== resolve) {
    handlePasswordSubmit = password => {
      if (resolve) {
        resolve(password);
      }
      closeModal();
    };
    handleCancel = () => {
      if (reject) {
        reject(new Error("Password entry canceled."));
      }
      closeModal();
    };
    const closeModal = () => {
      setAddress("");
      setAddressHashed("");
      setIsOpen(false);
      setResolve(undefined);
      setReject(undefined);
    };
    $[1] = reject;
    $[2] = resolve;
    $[3] = handleCancel;
    $[4] = handlePasswordSubmit;
  } else {
    handleCancel = $[3];
    handlePasswordSubmit = $[4];
  }
  let t1;
  if ($[5] !== handleCancel) {
    t1 = () => handleCancel();
    $[5] = handleCancel;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== handlePasswordSubmit) {
    t2 = pass => {
      handlePasswordSubmit(pass);
    };
    $[7] = handlePasswordSubmit;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== address || $[10] !== addressHashed || $[11] !== isOpen || $[12] !== t1 || $[13] !== t2) {
    const modal = <UnlockAppWalletModal address={address} address_hashed={addressHashed} show={isOpen} onHide={t1} onUnlock={t2} />;
    t3 = {
      requestPassword,
      modal
    };
    $[9] = address;
    $[10] = addressHashed;
    $[11] = isOpen;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
};